import { Promise } from 'es6-promise'
import commonRequest from 'Api/index'

const state = {
  objectSettings: {}
}

// getters
const getters = {
  OBJECT_SETTING_DATA: state => {
    return state.objectSettings
  }
}

// actions
const actions = {
  GET_OBJECT_SETTING: (context, payload) => {
    return new Promise((resolve, reject) => {
      commonRequest.getRequest(
        process.env.VUE_APP_BACKEND_CUST_URL,
        `/api/v1/customer_config/get_object_setting_with_key/`,
        payload,
        function (res) {
          context.commit('GET_OBJECT_SETTING_HANDLER', res.data)
          resolve(res)
        },
        function (error) {
          reject(error)
        }
      )
    })
  }
}

// mutations
const mutations = {
  GET_OBJECT_SETTING_HANDLER (state, payload) {
    state.objectSettings = payload.data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
